import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Support from "@mui/icons-material/Support";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Contact from "../Contact/contact";
import Button from "@mui/material/Button";
import We from "@mui/icons-material/Groups";
import AboutUs from "@mui/icons-material/PersonPinCircleOutlined";
import "./about.css";
import SqlEditor from "../SqlEditor/sqlEditor";
import { Typography } from "@material-ui/core";
//import ReactGA from "react-ga4";

const About = () => {
  useEffect(() => {
    //ReactGA.send("/about");
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Container
        maxWidth="sm xs lg"
        sx={{ backgroundColor: "white" }}
        disableGutters
      >
        <Box className="main-bg12">
          <Box className="main-title5">
            <h1>
              NOSOTROS{" "}
              <AboutUs
                sx={{ fontSize: 70, color: "#FFF", verticalAlign: "middle" }}
              />
            </h1>
          </Box>
        </Box>

        <Container maxWidth="sm xs lg" sx={{ backgroundColor: "white" }}>
          <Grid container spacing={3}>
            <Grid item xs sm lg>
              <img src="images/main_bg9.jpg" width="80%" />
            </Grid>
            <Grid item sm>
              <Box className="main-title2">
                <p className="text-main2">Apasionados por lo que Hacemos</p>
                <p className="subtext-main2">
                  Somos un equipo de apasionados por la programación y buscamos
                  compartir nuestros conocimientos y experiencias contigo.
                  <br />
                  <br />
                  Con años de experiencia en la industria,
                  <br />
                  estamos comprometidos para ayudarte a alcanzar
                  <br />
                  tus objetivos en el mundo de la tecnología.
                </p>
              </Box>
            </Grid>
          </Grid>
        </Container>

        <h3 style={{ textAlign: "center" }}>INSTRUCTORES</h3>
        <Container
          maxWidth="sm"
          sx={{ p: 2, backgroundColor: "f6f6f6" }}
          disableGutters
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={6}>
              <Box>
                <img src="images\mariano.png" />
                <p className="subtext-main5">
                  <b>Mariano Puglisi</b>
                  <br />
                  Analista de Sistemas
                </p>
                <Button
                  target="_blank"
                  href={"https://www.udemy.com/user/mariano-puglisi/"}
                  color="secondary"
                  variant="outlined"
                  size="medium"
                >
                  saber más
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <Box>
                <img src="images\perfilfernando.png" />
                <p className="subtext-main5">
                  <b>Fernando Burza</b>
                  <br />
                  Analista Programador
                </p>
                <Button
                  target="_blank"
                  href={"https://www.udemy.com/user/fernando-burza/"}
                  variant="outlined"
                  size="medium"
                  color="secondary"
                >
                  saber más
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
        <br />
        <br />
        <br />
        <br />
      </Container>

      <Contact />
    </>
  );
};

export default About;
